import { LIST_MATCHING_API_BASE_URL_V5 } from '../config';

export const ListMatchingAPIRoutes = {
  columns: () => `${LIST_MATCHING_API_BASE_URL_V5}/fetch_columns`,
  availableAttributes: () => `${LIST_MATCHING_API_BASE_URL_V5}/available_attributes`,
  mapData: () => `${LIST_MATCHING_API_BASE_URL_V5}/map_data`,
  segmentation: () => `${LIST_MATCHING_API_BASE_URL_V5}/segmentation`,
  columnSuggestions: () => `${LIST_MATCHING_API_BASE_URL_V5}/column_suggestions`,
  preview: () => `${LIST_MATCHING_API_BASE_URL_V5}/preview`,
  reservedColumns: () => `${LIST_MATCHING_API_BASE_URL_V5}/reserved_columns`,
  publish: () => `${LIST_MATCHING_API_BASE_URL_V5}/publish`,
  download: () => `${LIST_MATCHING_API_BASE_URL_V5}/download`,
};
